import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { getCredentials } from './utils/api';
import Home from './components/Home';
import Login from './components/admin/Login';
import AdminPage from './components/admin/AdminPage';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [checkingAuth, setCheckingAuth] = useState<boolean>(true);

  useEffect(() => {
    // Check if user has credentials stored
    const creds = getCredentials();
    if (creds) {
      setIsAuthenticated(true);
    }
    setCheckingAuth(false);
  }, []);

  const handleLogin = (): void => {
    setIsAuthenticated(true);
  };

  const handleLogout = (): void => {
    setIsAuthenticated(false);
  };

  if (checkingAuth) {
    return <div>Loading...</div>;
  }

  // Served at the root of hexmap.escaperope.ca. PUBLIC_URL is empty in development.
  const basename = process.env.PUBLIC_URL === '/' ? '' : (process.env.PUBLIC_URL || '');

  return (
    <BrowserRouter basename={basename}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route 
          path="/admin" 
          element={
            isAuthenticated ? (
              <AdminPage onLogout={handleLogout} />
            ) : (
              <Login onLogin={handleLogin} />
            )
          } 
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;

